











































import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import TextField from '@/components/form/TextField.vue';
import BillingAddress from '@/components/payment-forms/BillingAddressForm.vue';
import { namespace } from 'vuex-class';
import Booking from '@/types/taxcard/Booking';
import PaymentData from '@/types/store/checkout/PaymentData';

const BookingModule = namespace('booking');

@Component({
  components: {
    Button,
    TextField,
    BillingAddress,
  },
})
export default class SepaForm extends Vue {
  @Prop(Boolean)
  public paymentIsLoading: boolean = false;

  public firstname: string = '';

  public lastname: string = '';

  public email: string = '';

  public owner: string = '';

  public iban: string = '';

  public bic: string = '';

  @BookingModule.Getter
  public currentBooking!: Booking;

  public async created() {
    if (!this.currentBooking.isAnonymous) {
      const bIObject = this.currentBooking.bIObjects[0];
      this.owner = `${bIObject.bIObjectData.firstName} ${bIObject.bIObjectData.lastName}`;
      this.updateData();
    }
  }

  private updateBillingAddress(data: PaymentData) {
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.email = data.email;
    this.owner = `${this.firstname} ${this.lastname}`;
    this.updateData();
  }

  public formatIban(value: string): void {
    this.iban = value
      .replace(/[^0-9A-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .slice(0, 29);
  }

  private async updateData(): Promise<void> {
    const data = {
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      owner: this.owner,
      iban: this.iban.replace(/\s/g, ''),
      bic: this.bic.replace(/\s/g, ''),
    };
    this.$emit('update-data', data);
  }
}
